import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FeatureFlag, FeatureFlagsService } from '../../shared-services/featureFlags.service';

@Component({
  selector: 'app-feature-flags',
  templateUrl: './feature-flags.component.html',
  styleUrls: ['./feature-flags.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FeatureFlagsComponent implements OnInit {
  featureFlags: Array<FeatureFlag> = [];
  originalValues: { [id: number]: boolean } = {};

  constructor(private featureFlagsService: FeatureFlagsService,) { }

  async ngOnInit() {
    await this.loadFeatureFlags();
  }

  async loadFeatureFlags() {
    this.featureFlags = await this.featureFlagsService.getAll();
    // Store original values
    this.featureFlags.forEach(flag => {
      this.originalValues[flag.id] = flag.isActive;
      const stored = localStorage.getItem(`persist-featureFlag_${flag.id}_isActive`);
      if (stored !== null) {
        flag.isActive = stored === 'true';
      }
    });
  }

  onToggleIsActive(flag: FeatureFlag) {
    flag.isActive = !flag.isActive;
    if (flag.isActive !== this.originalValues[flag.id]) {
      localStorage.setItem(`persist-featureFlag_${flag.id}_isActive`, String(flag.isActive));
    } else {
      localStorage.removeItem(`persist-featureFlag_${flag.id}_isActive`);
    }
  }

  isOverridden(flag: FeatureFlag): boolean {
    return flag.isActive !== this.originalValues[flag.id];
  }

  restoreAllOverrides(): void {
    this.featureFlags.forEach(flag => {
      if (this.isOverridden(flag)) {
        localStorage.removeItem(`persist-featureFlag_${flag.id}_isActive`);
        flag.isActive = this.originalValues[flag.id];
      }
    });
  }

  async refreshFeatureFlags(): Promise<void> {
    await this.loadFeatureFlags();
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/feature-flags/feature-flags.component.ts